<template>
  <div class="animated fadeIn">
    <div class="col-sm-12 col-md-12">
      <div class="loading" v-if="processando"> 
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
        </div>
      </div>
      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMudarMotorista">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mudar Motorista</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <div class="form-group col-sm-12 col-md-12">
                    <label>Motorista:</label><br>
                    <input id="motoristaId" type="hidden" class="form-control" v-model="motoristaId">
                    <buscar-motorista  id="motoristaNome" placeholder="Selecione um motorista.." v-model="motoristaNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :on-select="setarMotorista" :on-blur="verificarMotorista" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="mudarMotorista">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMudarMotorista = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMudarMotivo">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mudar Motivo</h4>
            </div> 
            <div class="modal-body">
              <input id="modalItemId" type="hidden" class="pula form-control" required="required">
              <template v-if="selecionada === '' || selecionada === '0'">
              <div id="modalMudarMotivoMensagem">Não foi selecionado um lançamento<br> Serão trocados todos os lançamentos sem Motivos.</div><br>
              </template>
              <div class="row">
                <div class="form-group col-sm-12 col-md-12">
                  <label>Motivo:</label><br>
                  <select class="pula form-control" v-model="mudarMotivoId">
                    <option value="03">03 - Espera</option>
                    <option value="04">04 - Alimentacao</option>
                    <option value="05">05 - Descanso Direcao</option>
                    <option value="06">06 - Abastecimento</option>
                    <option value="07">07 - Fiscalizacao</option>
                    <option value="08">08 - Manutencao em Jornada</option>
                    <option value="09">09 - Contato</option>
                    <option value="10">10 - "Socorro"</option>
                    <option value="11">11 - Transito</option>
                    <option value="34">34 - Diaria</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="mudarMotivo">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMudarMotivo = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalDividirTempo">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Dividir Tempo</h4>
            </div> 
            <div class="modal-body">
              <input id="modalItemIdManual" type="hidden" class="pula form-control" required="required" value="551058">
              <div class="row">
                <div class="form-group col-sm-4 col-md-4">
                  <label>Data Hora Inicio:</label><br>
                  <input type="hidden" class="pula dataHora form-control"  v-model="dividirTempo.dataHoraInicioControleManual">
                  <input class="pula dataHora form-control" required="required" readonly="readonly" v-model="dividirTempo.dataHoraInicio">
                </div>
                <div class="form-group col-sm-4 col-md-4">
                  <label>Data Hora Final:</label><br>
                  <input type="hidden" class="pula dataHora form-control" v-model="dividirTempo.dataHoraFinalControleManual">
                  <input class="pula dataHora form-control" required="required" v-model="dividirTempo.dataHoraFinal">
                </div>
                <div class="form-group col-sm-4 col-md-4">
                  <label>Duração:</label><br>
                  <input class="pula form-control" readonly="readonly" v-model="dividirTempo.dataHoraDuracao">
                </div>
              </div>
              
              <div class="row">
                <div class="form-group col-sm-12 col-md-12">
                  <label>Status:</label><br>
                  <select class="pula form-control" required="required" disabled="true" v-model="dividirTempo.statusVeiculo">
                    <option value="VEICULO PARADO">VEICULO PARADO</option>
                    <option value="VEICULO EM MOVIMENTO">VEICULO EM MOVIMENTO</option>
                    <option value="EM DIARIA">EM DIARIA</option>
                  </select>
                </div>
              </div>
              
              <div class="row">
                <div class="form-group col-sm-12 col-md-12">
                  <label>Motivo:</label><br>
                  <select class="pula form-control" v-model="dividirTempo.motivo">
                    <option value="03">03 - Espera</option>
                    <option value="04">04 - Alimentacao</option>
                    <option value="05">05 - Descanso Direcao</option>
                    <option value="06">06 - Abastecimento</option>
                    <option value="07">07 - Fiscalizacao</option>
                    <option value="08">08 - Manutencao em Jornada</option>
                    <option value="09">09 - Contato</option>
                    <option value="10">10 - "Socorro"</option>
                    <option value="11">11 - Transito</option>
                    <option value="34">34 - Diaria</option>
                  </select>
                </div>
              </div>
              
              <div class="row">
                <div class="form-group col-sm-12 col-md-12">
                  <label class="control-label">Observação:</label><br>
                  <textarea class="pula form-control" v-model="dividirTempo.observacao"></textarea>
                </div>
              </div>
              <input id="modalItemAutomaticoManual" type="hidden" value="false">
              
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success" data-dismiss="modal" v-on:click="gravarDividirTempo">Gravar</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalDividirTempo = false">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade show " id="modal-mapa" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content"> 
            <div class="modal-body">
                  <a class="close" data-dismiss="modal" aria-label="Fechar" style=" z-index: 1000000; font-size: 69px; color: #000; float: right; right: 0; position: absolute; top: -40px; opacity: 1;" v-on:click="showModalMapa = false">
                    <span aria-hidden="true">&times;</span>
                  </a>
                  <gmap-map
                    :center="center"
                    :zoom="12"
                    ref="map"
                    :options="{ gestureHandling: 'greedy'}"
                    style="width:calc(100vw - 28px);  height: calc(100vh - 64px)"
                  >
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                      <span v-html="infoContent"></span>
                    </gmap-info-window>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      @click="toggleInfoWindow(m,index)"
                    ></gmap-marker>
                    <gmap-polyline v-if="path.length > 0" :path="path" :editable="false"
                        ref="polyline">
                    </gmap-polyline>
                  </gmap-map>  
                  
                </div>
            <!-- <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div> -->
          </div>
        </div>
      </div>
      <!-- <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
        aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
        data-backdrop="static" v-if="showModalMapa">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Mudar Motivo</h4>
            </div> 
            <div class="modal-body">
              <div class="col-md-12">                  
                <div class="row">
                  <gmap-map
                    :center="center"
                    :zoom="4"
                    ref="map"
                    style="width:calc(100vw - 58px);  height: calc(100vh - 220px)"
                  >
                    <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                      <span v-html="infoContent"></span>
                    </gmap-info-window>
                    <gmap-marker
                      :key="index"
                      v-for="(m, index) in markers"
                      :position="m.position"
                      :labelClass="'labels'"
                      :label="{
                        color: 'gray',
                        backgroundColor: '#FFF',
                        fontSize: '12px',
                        text: m.descricao
                      }"
                      @click="toggleInfoWindow(m,index)"
                    ></gmap-marker>
                  </gmap-map>  
                  
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal" v-on:click="showModalMapa = false">Fechar</button>
            </div>
          </div>
        </div>
      </div> -->

      <div class="card">
        <div class="card-body">
          <div class="row row-margin">
            <div class="col-sm-12 col-md-12">
              <h4>Editar Jornada</h4>
            </div>
          </div>
          <div class="row row-margin">
            <div class="col-md-12">
              
              <input id="botaoMudarMotivo" class="btn btn-success" type="submit" value="Salvar" v-on:click="salvar">
              <input id="botaoMudarMotivo" class="btn btn-primary" type="submit" value="Mudar Motivo" v-on:click="mudarMotivoModal">
              <router-link class="btn btn-warning" to="/gestaoJornada">
                <span class="glyphicon glyphicon-back"></span> Fechar
              </router-link>
            </div>
          </div>
          <br>
          <div class="row row-margin">
            <div class="col-md-5">
              <strong>Data: </strong>De: {{jornada.dataHoraInicial}} até {{jornada.dataHoraFinal}}
            </div>
            <div class="col-md-3">
              <strong>Veículo: </strong> {{jornada.veiculoDescricao}}
            </div>
            <div class="col-md-3">
              <strong>Motorista: </strong> {{jornada.motoristaNome}}<br>
              <a href="#">
                <span v-on:click="showModalMudarMotorista = true">Mudar motorista</span>
              </a>
            </div>
          </div>
          <br>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>PERIODO</th>
                <th>DURAÇÃO</th>
                <th></th>
                <th>MOTIVO</th>
                <th>TIPO</th>
                <th>OBSERVAÇÃO</th>
                <th></th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in jornadaItens" >
              <tr v-bind:class="{ 'selecionado': selecionado(grid), 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }" @click="selecionarItem(grid, $event)" >
                <td width="140"><small>{{grid.dataHoraInicio}}<br>{{grid.dataHoraFinal}}</small></td>
                <td width="85"><small>{{grid.dataHoraDuracao}}</small></td>
                <td width="200"><small>{{grid.statusVeiculo}}</small></td>
                <td width="205"><small>{{grid.motivo}}</small></td>
                <td><small>{{grid.tipoMotivo}}</small></td> 
                <!-- <td>{{grid.movimentoSecundario}}</td> -->
                <td width="150"><small>{{grid.observacao}}</small></td>
                <td class="text-right">
                  <template v-if="grid.statusVeiculo === 'VEICULO PARADO'" >
                    <template v-if="grid.latitude !== '' && grid.latitude !== '0.0;'"  >
                      <a v-tooltip="'Ver Mapa'" v-on:click="visualizarMapa(grid)" href="#">
                        <img src="/static/images/ponto.png" />
                      </a>
                    </template>
                  </template>
                  <template v-if="grid.statusVeiculo === 'VEICULO PARADO' || grid.statusVeiculo === 'EM DIARIA'">
                    <a v-tooltip="'Editar'" v-on:click="showDividirTempo(grid.id)" href="#">
                      <img src="/static/images/editar.png" />
                    </a>
                  </template>
                </td>
                <!-- <td>{{latitude}}</td>
                <td>{{longitude}}</td>
                <td>{{icone}}</td>
                <td>{{kmRodados}}</td>
                <td>{{velocidadeMaxima}}</td>
                <td>{{velocidadeMedia}}</td>
                <td>{{alerta}}</td>
                <td>{{error}}</td>
                <td>{{automatico}}</td>
                <td>{{mudouDia}}</td> -->
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-4 text-center"></div>
            <div class="col-md-4 text-center"><br><h5><strong>TOTAIS</strong></h5></div>
            <div class="col-md-4 text-center"></div>
          </div>

          <div class="row">
            <div class="col-md-2 text-right">
              Tempo em Jornada: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoJornada}} </strong><br/>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-2 text-right">
              Direção: <br/>
              Diária: <br/>
              Abastecimento: <br/>
              Manutenção: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoDirecao}} </strong><br/>
              <strong> {{jornada.tempoDiaria}} </strong><br/>
              <strong> {{jornada.tempoAbastecimento}} </strong><br/>
              <strong> {{jornada.tempoManutencao}} </strong><br/>
            </div>

            <div class="col-md-2 text-right">
              Carga e Descarga: <br/>
              Fiscalização: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoCargaDescarga}} </strong><br/>
              <strong> {{jornada.tempoFiscalizacao}} </strong><br/>
            </div>

            <div class="col-md-2 text-right">
              Descanso de Direção: <br/>
              Alimentação: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoDescansoDirecao}} </strong><br/>
              <strong> {{jornada.tempoAlimentacao}} </strong><br/>
            </div>

            <div class="col-md-2 text-right">
              Adicional Noturno: <br/>
              Hora Extra Normal 1:<br/>
              Hora Extra Normal 2: <br/>
              Hora Extra Noturna 1:<br/>
              Hora Extra Noturna 2: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoAdicionalNoturno}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNormal1}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNormal2}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNoturna1}} </strong><br/>
              <strong> {{jornada.tempoHoraExtraNoturna2}} </strong><br/>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-md-2 text-right">
              Total Trabalhando: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoHoraTrabalhada}} </strong><br/>
            </div>

            <div class="col-md-2 text-right">
              Total Indenizada: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoHoraIndenizada}} </strong><br/>
            </div>

            <div class="col-md-2 text-right">
              Total Descanso: <br/>
            </div>
            <div class="col-md-1">
              <strong> {{jornada.tempoHoraDescanso}} </strong><br/>
            </div>

            <div class="col-md-3 text-right">
            </div>
          </div>

				</div>
      </div>
    </div>
	</div>
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0"></script>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalMudarMotivo: false,
      showModalDividirTempo: false,
      dividirTempo: {
        id: '0',
        dataHoraInicio: '',
        dataHoraInicioManual: '',
        dataHoraInicioControleManual: '',
        dataHoraFinal: '',
        dataHoraFinalManual: '',
        dataHoraFinalControleManual: '',
        dataHoraDuracao: '',
        statusVeiculo: '',
        motivo: '03',
        tipoMotivo: '',
        observacao: ''
      },
      showModalMapa: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: '',
      mudarMotivoId: '0',
      selecionada: '0',
      selecionados: [],
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      places: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    }
  },
  created: function () {
    this.buscar()
    this.buscarItens()
  },
  mounted: function () {
    $('.pula').keypress(function (e) {
      var tecla = (e.keyCode ? e.keyCode : e.which)
      if (tecla === 13) {
        let campo = $('.pula')
        let indice = campo.index(this)
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus()
        }
        if (campo[indice + 1] != null) {
          let proximo = campo[indice + 1]
          proximo.focus()
        }
        e.preventDefault(e)
        return false
      }
    })
  },
  methods: {
    selecionarItem: function (item, event) {
      this.selecionada = item.id
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          let p = this.selecionados.indexOf(item)
          this.selecionados.splice(p, 1)
        } else {
          this.selecionados.push(item)
        }
      } else {
        this.selecionados = []
        this.selecionados.push(item)
      }
    },
    selecionado: function (item) {
      return this.selecionados.includes(item)
    },
    buscar: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.jornada = dados
      })
    },
    buscarItens: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        var dados = response.data
        self.jornadaItens = dados
      })
    },
    mudarMotorista: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.showModalMudarMotorista = false
          self.buscar()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    mudarMotivoModal: function () {
      let self = this
      self.showModalMudarMotivo = true
    },
    mudarMotivo: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = ''
      if (self.selecionados.length === 0) {
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id
      } else {
        var gestaoJornadaItemIds = ''
        for (let i = 0; i < self.selecionados.length; i++) {
          if (i === 0) {
            gestaoJornadaItemIds = self.selecionados[i].id
          } else {
            gestaoJornadaItemIds = gestaoJornadaItemIds + ';' + self.selecionados[i].id
          }
        }
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=' + gestaoJornadaItemIds + '&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id
      }
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.showModalMudarMotivo = false
          self.buscar()
          self.buscarItens()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    setarMotorista: function (motorista) {
      this.motoristaId = motorista.id
      this.motoristaNome = motorista.nome
      $(this.$el).find('#motoristaNome').val(motorista.nome)
    },
    verificarMotorista: function () {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0
        this.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0
        this.motoristaNome = ''
        $(this.$el).find('#motoristaId').val(0)
        $(this.$el).find('#motoristaNome').val('')
      }
    },
    showDividirTempo: function (jornadaId) {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/buscarJornadaItem?id=' + jornadaId
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        self.processando = false
        self.showModalDividirTempo = true
        var dados = response.data
        self.dividirTempo.id = dados.id
        self.dividirTempo.dataHoraInicio = dados.dataHoraInicio
        self.dividirTempo.dataHoraFinal = dados.dataHoraFinal
        self.dividirTempo.dataHoraDuracao = dados.dataHoraDuracao
        self.dividirTempo.statusVeiculo = dados.statusVeiculo
        self.dividirTempo.motivo = dados.motivo
        self.dividirTempo.tipoMotivo = dados.tipoMotivo
        self.dividirTempo.observacao = dados.observacao
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    gravarDividirTempo: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + self.dividirTempo.id + '&dataHoraInicio=' + self.dividirTempo.dataHoraInicio + '&dataHoraFinal=' + self.dividirTempo.dataHoraFinal + '&dataHoraDuracao=' + self.dividirTempo.dataHoraDuracao + '&motivo=' + self.dividirTempo.motivo + '&observacao=' + self.dividirTempo.observacao + '&status=' + self.dividirTempo.statusVeiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.showModalDividirTempo = false
          self.buscar()
          self.buscarItens()
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    visualizarMapa: function (grid) {
      let self = this
      self.showModalMapa = true
      self.adicionarMarkers(grid)
    },
    adicionarMarkers (grid) {
      let self = this
      self.removerMarkers()
      let bounds = null
      let myLatLng = null
      var latitudes = grid.latitude.split(';')
      var longitudes = grid.longitude.split(';')
      for (let i = 0; i < latitudes.length; i++) {
        if (latitudes[i] !== '') {
          let marker = {
            lat: parseFloat(latitudes[i]),
            lng: parseFloat(longitudes[i])
          }
          self.markers.push({ position: marker })
          self.center = { lat: marker.lat, lng: marker.lng }
          // self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[i].hora, ignicao: self.dadosRelatorios.dados[i].ignicao, velocidade: self.dadosRelatorios.dados[i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[i].pontoMaisProximo })
          // self.path.push({
          //   lat: parseFloat(latitudes[i]),
          //   lng: parseFloat(longitudes[i])
          // })
          myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
          bounds = new window.google.maps.LatLngBounds()
          bounds.extend(myLatLng)
          // let myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
          // bounds.extend(myLatLng)
        }
        // }
      }
      self.$refs.map.fitBounds(bounds)
      self.currentPlace = null
    },
    removerMarkers () {
      let self = this
      self.markers = []
      self.path = []
    },
    salvar: function () {
      var self = this
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      self.processando = true
      var url = '/api/gestaoJornadas/salvar'
      axios.post(url, JSON.stringify(self.jornada), config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.$router.replace('/gestaoJornada')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/jornadasconvencoes/GestaoJornadasConvencaoEditar.vue